import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6932db6a5a24100014374961/the_vibe_inventor/src/app/project-portfolio/components/ProjectPortfolioInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6932db6a5a24100014374961/the_vibe_inventor/src/components/common/Header.tsx");
